import { Resource } from "react-admin";
import React from "react";

export default <Resource name="installation_types" />;



// WEBPACK FOOTER //
// ./src/resources/InstallationTypes/index.js